module.exports = __webpack_public_path__ + "img/tu_schedule_travel_active.e38e5dde.svg";